import Header from './Header.js';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

export default function Home() {
    const codeSnippet = "import boto3\n\n" +
        "ec2 = boto3.client('ec2')\n" +
        "response = ec2.describe_instances(Filters=[\n" +
        "    {'Name': 'instance-state-name', 'Values': ['running']}\n" +
        "])";

    return <>
        <Header />
        <section className='hero' id="hero">
            <div className='code-editor'>
                <div className='code-editor-tabs'>
                    <div className='window-controls' aria-hidden='true'>
                        <span className='window-control close'></span>
                        <span className='window-control minimize'></span>
                        <span className='window-control maximize'></span>
                    </div>
                    <div className='code-tab active'>
                        <img className='tab-icon' src='/img/technology-stack-images/python.svg' alt='Python'/>
                        <span>boto_response.py</span>
                    </div>
                </div>
                <div className='code-editor-content'>
                    <SyntaxHighlighter
                        language='python'
                        style={vscDarkPlus}
                        showLineNumbers={true}
                        wrapLongLines={false}
                        customStyle={{
                            background: 'transparent',
                            padding: 0,
                            margin: 0,
                            fontSize: 'calc(0.85rem + 0.3vw)',
                            lineHeight: '1.7'
                        }}
                        codeTagProps={{
                            style: {
                                fontSize: 'calc(0.85rem + 0.3vw)',
                                lineHeight: '1.7'
                            }
                        }}
                        lineNumberStyle={{
                            color: '#4a4a5e',
                            fontSize: 'calc(0.75rem + 0.3vw)'
                        }}
                    >
                        {codeSnippet}
                    </SyntaxHighlighter>
                </div>
            </div>
            <div className='home-hero-text'>
                <h1> Hello! 👋 I'm Andrew Dawson</h1>
                <h3 style={{maxWidth: '800px', margin:'0 auto'}}>Software Engineer currently working in the field of AI Cybersecurity</h3>
            </div>
            <a href='#about' className='scroll-indicator'>
                <span className='scroll-text'>Scroll to find out more</span>
                <div className='chevron'></div>
                <div className='chevron'></div>
            </a>
        </section>
        <section className='about' id="about">
            <div className="about-content-wrapper">
                <div className="who-i-am-section">
                    <h2>About Me</h2>
                    
                    <div className="who-i-am-grid">
                        <div className="who-i-am-card">
                            <div className="card-icon">👤</div>
                            <h3>Personal</h3>
                            <p>Experienced <strong>Software Engineer</strong> with a Masters in <strong>Theoretical Physics</strong>. I'm passionate about implementing <strong>robust solutions</strong> that stand the test of time, avoiding quick fixes that create technical debt.</p>
                        </div>
                        
                        <div className="who-i-am-card">
                            <div className="card-icon">💼</div>
                            <h3>Career</h3>
                            <p>Working in <strong>AI Cybersecurity</strong>, focusing on protecting companies from <strong>unknown insider and outsider threats</strong>. I leverage <strong>major cloud platforms</strong> daily to architect scalable, secure systems.</p>
                        </div>
                        
                        <div className="who-i-am-card">                            <div className="card-icon">🎯</div>                            <h3>Future Goals</h3>
                            <p><strong>Full-Stack Enthusiast</strong> continuously improving front-end skills. My long-term vision is to become a <strong>tech manager</strong> leading teams to create products that empower users across all fields.</p>
                        </div>
                    </div>
                </div>
                
                <div className="tech-stack-section">
                    <h2>My Technology Stack</h2>
                    <div className='technology-stack-carousel'>
                        <div className='technology-stack-track'>
                            <img className='svg-icon' src='/img/technology-stack-images/python.svg' alt='Python'/>
                            <img className='svg-icon' src='/img/technology-stack-images/docker.svg' alt='Docker'/>
                            <img className='svg-icon' src='/img/technology-stack-images/kubernetes.svg' alt='Kubernetes'/>
                            <img className='svg-icon' src='/img/technology-stack-images/git.svg' alt='Git'/>
                            <img className='svg-icon' src='/img/technology-stack-images/postgresql.svg' alt='PostgreSQL'/>
                            <img className='svg-icon' src='/img/technology-stack-images/aws.svg' alt='AWS'/>
                            <img className='svg-icon' src='/img/technology-stack-images/gcp.svg' alt='Google Cloud Platform'/>
                            <img className='svg-icon' src='/img/technology-stack-images/azure.svg' alt='Azure'/>
                            <img className='svg-icon' src='/img/technology-stack-images/python.svg' alt='Python'/>
                            <img className='svg-icon' src='/img/technology-stack-images/docker.svg' alt='Docker'/>
                            <img className='svg-icon' src='/img/technology-stack-images/kubernetes.svg' alt='Kubernetes'/>
                            <img className='svg-icon' src='/img/technology-stack-images/git.svg' alt='Git'/>
                            <img className='svg-icon' src='/img/technology-stack-images/postgresql.svg' alt='PostgreSQL'/>
                            <img className='svg-icon' src='/img/technology-stack-images/aws.svg' alt='AWS'/>
                            <img className='svg-icon' src='/img/technology-stack-images/gcp.svg' alt='Google Cloud Platform'/>
                            <img className='svg-icon' src='/img/technology-stack-images/azure.svg' alt='Azure'/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className='experience' id="experience">
            <h2 className='section-title'>Experience & Education</h2>
            <div className='experience-item-container'>
                <div className='experience-item'>
                    <div className='experience-item-main'>
                        <div className='horizontal-flex-container gap-20'>
                            <img src="/img/darktrace-logo.png"/>
                            <div className='experience-item-content'>
                                <h3>Software Engineer</h3>
                                <p>Darktrace · Full-time</p>
                                <p>Feb 2025 - Present</p>
                                <p>Cambridge, England, United Kingdom</p>
                            </div>
                        </div>
                    </div>
                    <div className='experience-item-details'>
                        <div className='details-group'>
                            <h4>Technologies</h4>
                            <p>Python, AWS, Docker, Kubernetes</p>
                        </div>
                        <div className='details-group'>
                            <h4>Focus</h4>
                            <p>AI Cybersecurity, Threat Detection, Machine Learning</p>
                        </div>
                    </div>
                </div>
                <div className='experience-item'>
                    <div className='experience-item-main'>
                        <div className='horizontal-flex-container gap-20'>
                            <img src="/img/cthings-logo.png"/>
                            <div className='experience-item-content'>
                                <h3>Backend Software Developer</h3>
                                <p>cThings Limited · Full-time</p>
                                <p>Jun 2022 - Feb 2025</p>
                                <p>Cambridge, England, United Kingdom</p>
                            </div>
                        </div>
                    </div>
                    <div className='experience-item-details'>
                        <div className='details-group'>
                            <h4>Technologies</h4>
                            <p>Python, AWS, LoRaWAN</p>
                        </div>
                        <div className='details-group'>
                            <h4>Focus</h4>
                            <p>IOT, API Development, Database Management, Metric Collection</p>
                        </div>
                    </div>
                </div>
                <div className='experience-item'>
                    <div className='experience-item-main'>
                        <div className='horizontal-flex-container gap-20'>
                            <img src="/img/nottingham-university-logo.png"/>
                            <div className='experience-item-content'>
                                <h3>Quantum Information and Cold Atoms Summer Research Intern</h3>
                                <p>University of Nottingham · Internship</p>
                                <p>Jul 2021 - Sep 2021</p>
                                <p>Nottingham, England, United Kingdom</p>
                            </div>
                        </div>
                    </div>
                    <div className='experience-item-details'>
                        <div className='details-group'>
                            <h4>Technologies</h4>
                            <p>Python, Scientific Computing</p>
                        </div>
                        <div className='details-group'>
                            <h4>Focus</h4>
                            <p>Quantum Physics Research, Data Analysis, Machine Learning, Cold Atom Experiments</p>
                        </div>
                    </div>
                </div>
                <div className='experience-item'>
                    <div className='experience-item-main'>
                        <div className='horizontal-flex-container gap-20'>
                            <img src="/img/nottingham-university-logo.png"/>
                            <div className='experience-item-content'>
                                <h3>MSci Physics with Theoretical Physics</h3>
                                <p>University of Nottingham · Master's Degree</p>
                                <p>Sep 2018 - Sep 2021</p>
                                <p>Nottingham, England, United Kingdom</p>
                            </div>
                        </div>
                    </div>
                    <div className='experience-item-details'>
                        <div className='details-group'>
                            <h4>Specialization</h4>
                            <p>Theoretical Physics, Quantum Mechanics</p>
                        </div>
                        <div className='details-group'>
                            <h4>Grade</h4>
                            <p>First Class Honours</p>
                        </div>
                    </div>
                </div>
                <div className='experience-item'>
                    <div className='experience-item-main'>
                        <div className='horizontal-flex-container gap-20'>
                            <a target='_blank' rel='noopener noreferrer' href='https://www.credly.com/badges/088b3314-8638-48b9-a089-7f6fa418c99f/public_url'><img src='/img/technology-stack-images/aws-certified-cloud-practitioner.png' alt='AWS Certified Cloud Practitioner'/></a>
                            <div className='experience-item-content'>
                                <h3>AWS Certified Cloud Practitioner</h3>
                                <p>Amazon Web Services (AWS) · Certification</p>
                                <p>Valid credential</p>
                            </div>
                        </div>
                    </div>
                    <div className='experience-item-details'>
                        <div className='details-group'>
                            <h4>Topics</h4>
                            <p>AWS Services, Cloud Architecture, Security, Billing, Identity and Access Management</p>
                        </div>
                    </div>
                </div>
            </div>

        </section>
        <section className='projects' id='projects'>
            <h2 className='section-title'>Projects</h2>
            <div className='projects-grid'>
                <article className='project-card'>
                    <img src='/img/schemalens-banner.svg' alt='Schema Lens'/>
                    <div className='project-card-content'>
                        <h3 className='project-card-title'>Schema Lens</h3>
                        <p className='project-card-description'>A Postgres schema visualizer with an interactive graph UI and container-ready deployment.</p>
                        <div className='project-card-meta'>
                            <span>Stack: React, Python, Postgres, Docker</span>
                        </div>
                        <div className='project-card-links'>
                            <a href='https://demo.d10e2ku9mfjvbj.amplifyapp.com/' className='project-link'>
                                <span className='project-link-icon' aria-hidden='true'>
                                    <svg viewBox='0 0 24 24' role='img' aria-hidden='true'>
                                        <path d='M14 3h7v7'/>
                                        <path d='M21 3l-10 10'/>
                                        <path d='M5 7v11a3 3 0 0 0 3 3h11'/>
                                    </svg>
                                </span>
                                Demo
                            </a>
                            <a href='https://github.com/andrewdawsonphys/SchemaLens' className='project-link'>
                                <span className='project-link-icon' aria-hidden='true'>
                                    <svg viewBox='0 0 24 24' role='img' aria-hidden='true'>
                                        <path d='M12 2C6.48 2 2 6.58 2 12.23c0 4.52 2.87 8.36 6.84 9.72.5.09.68-.22.68-.49 0-.24-.01-1.04-.01-1.89-2.78.62-3.37-1.2-3.37-1.2-.45-1.18-1.11-1.49-1.11-1.49-.91-.64.07-.63.07-.63 1 .07 1.53 1.05 1.53 1.05.9 1.58 2.35 1.12 2.92.86.09-.67.35-1.12.63-1.38-2.22-.26-4.55-1.15-4.55-5.1 0-1.13.39-2.05 1.03-2.77-.1-.26-.45-1.31.1-2.73 0 0 .84-.28 2.75 1.06A9.3 9.3 0 0 1 12 6.79c.85 0 1.71.12 2.51.36 1.91-1.34 2.75-1.06 2.75-1.06.55 1.42.2 2.47.1 2.73.64.72 1.03 1.64 1.03 2.77 0 3.96-2.33 4.84-4.56 5.09.36.32.68.94.68 1.89 0 1.36-.01 2.46-.01 2.8 0 .27.18.59.69.49A10.25 10.25 0 0 0 22 12.23C22 6.58 17.52 2 12 2Z'/>
                                    </svg>
                                </span>
                                Code
                            </a>
                        </div>
                    </div>
                </article>
                <article className='project-card'>
                    <img src='/img/mnist-banner.png' alt='MNIST Digit Neural Network'/>
                    <div className='project-card-content'>
                        <h3 className='project-card-title'>MNIST Digit Neural Network from Scratch</h3>
                        <p className='project-card-description'>A handwritten digit classifier from first principles using only NumPy. No PyTorch. 
                            No TensorFlow. No automatic differentiation</p>
                        <div className='project-card-meta'>
                            <span>Stack: Python</span>
                        </div>
                        <div className='project-card-links'>
                            <span className='project-link project-link-disabled' aria-disabled='true'>
                                <span className='project-link-icon' aria-hidden='true'>
                                    <svg viewBox='0 0 24 24' role='img' aria-hidden='true'>
                                        <path d='M14 3h7v7'/>
                                        <path d='M21 3l-10 10'/>
                                        <path d='M5 7v11a3 3 0 0 0 3 3h11'/>
                                    </svg>
                                </span>
                                Live
                            </span>
                            <a href='https://github.com/andrewdawsonphys/Digit-Recognition-From-Scratch' className='project-link'>
                                <span className='project-link-icon' aria-hidden='true'>
                                    <svg viewBox='0 0 24 24' role='img' aria-hidden='true'>
                                        <path d='M12 2C6.48 2 2 6.58 2 12.23c0 4.52 2.87 8.36 6.84 9.72.5.09.68-.22.68-.49 0-.24-.01-1.04-.01-1.89-2.78.62-3.37-1.2-3.37-1.2-.45-1.18-1.11-1.49-1.11-1.49-.91-.64.07-.63.07-.63 1 .07 1.53 1.05 1.53 1.05.9 1.58 2.35 1.12 2.92.86.09-.67.35-1.12.63-1.38-2.22-.26-4.55-1.15-4.55-5.1 0-1.13.39-2.05 1.03-2.77-.1-.26-.45-1.31.1-2.73 0 0 .84-.28 2.75 1.06A9.3 9.3 0 0 1 12 6.79c.85 0 1.71.12 2.51.36 1.91-1.34 2.75-1.06 2.75-1.06.55 1.42.2 2.47.1 2.73.64.72 1.03 1.64 1.03 2.77 0 3.96-2.33 4.84-4.56 5.09.36.32.68.94.68 1.89 0 1.36-.01 2.46-.01 2.8 0 .27.18.59.69.49A10.25 10.25 0 0 0 22 12.23C22 6.58 17.52 2 12 2Z'/>
                                    </svg>
                                </span>
                                Code
                            </a>
                        </div>
                    </div>
                </article>
            </div>
        </section>
        <section className='contact' id="contact">
            <h2 className='section-title'>Get In Touch</h2>
            <div className='contact-container'>
                <p className='contact-description'>I'm always interested in hearing about new opportunities and interesting projects. Feel free to reach out!</p>
                <div className='contact-links horizontal-flex-container'>
                    <a href='https://uk.linkedin.com/in/andrew--dawson' target='_blank' rel='noopener noreferrer' className='contact-link'>LinkedIn</a>
                    <a href='mailto:andrewdawsonapple@gmail.com' className='contact-link'>Email</a>
                </div>
            </div>
        </section>
        <footer>
            <div className='footer-container'>
                <div className='footer-content-container horizontal-flex-container align-center space-between'>
                    <div className='footer-about-me-text'>
                        <h3>Andrew Dawson</h3>
                        <p>Software Engineer</p>
                    </div>
                    <div className='footer-social-media-group horizontal-flex-container align-center gap-20'>
                        <a target='_blank' rel='noopener noreferrer' href='https://uk.linkedin.com/in/andrew--dawson'><img className='svg-icon' src='/img/social-media-icons/linkedin.svg' alt='LinkedIn'/></a>
                        <a href='mailto:andrewdawsonapple@gmail.com'><img className='svg-icon' src='/img/social-media-icons/email.svg' alt='Email' style={{filter: 'brightness(0) invert(1)', marginBottom: '-5px'}}/></a>
                    </div>
                </div>
                <div className='footer-copyright'>
                    <hr></hr>
                    <p>© Copyright {new Date().getFullYear()}. Created By Andrew Dawson</p>
                </div>
            </div>
        </footer>
    </>
}
